import { render, staticRenderFns } from "./NoDataContent.vue?vue&type=template&id=d38c8e7e&scoped=true&"
import script from "./NoDataContent.vue?vue&type=script&lang=js&"
export * from "./NoDataContent.vue?vue&type=script&lang=js&"
import style0 from "./NoDataContent.vue?vue&type=style&index=0&id=d38c8e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38c8e7e",
  null
  
)

export default component.exports